import { AnyObject, PointResponse, DiagonalCoords } from '../../constants/types'
import { POINTS_URL } from '../../constants/urls'
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { MethodsEnum } from '../../constants/enums'
import { FormSaveResponse } from '@epam/uui-core'
import { reviewsApi } from '../reviews/reviews.api'

export const pointsApi = createApi({
  reducerPath: 'points/api',
  baseQuery: fetchBaseQuery({
    baseUrl: POINTS_URL,
  }),
  tagTypes: ['Point'],
  endpoints: (build) => ({
    getPoint: build.query<PointResponse[], number>({
      query: (pointId: number) => ({
        url: '',
        credentials: 'include',
        params: {
          id: pointId,
        },
      }),
      providesTags: (result, error, arg) =>
        result
          ? [...result.map(({ id }) => ({ type: 'Point' as const, id }))]
          : ['Point'],
    }),
    getPoints: build.mutation<PointResponse[], DiagonalCoords>({
      query: ({ nwLat, nwLng, seLat, seLng }) => ({
        url: '',
        method: MethodsEnum.GET,
        credentials: 'include',
        params: {
          nwLat,
          nwLng,
          seLat,
          seLng,
        },
      }),
    }),
    postPoint: build.mutation<FormSaveResponse<any>, AnyObject | null>({
      query: (body: AnyObject | null) => ({
        url: '',
        method: MethodsEnum.POST,
        body: body,
        credentials: 'include',
      }),
      invalidatesTags: ['Point'],
    }),
    putPoint: build.mutation<FormSaveResponse<any>, AnyObject | null>({
      query: (body: AnyObject | null) => ({
        url: '',
        method: MethodsEnum.PUT,
        body: body, //TODO: redux test
        credentials: 'include',
      }),
      onQueryStarted: (arg, api) => {
        api.queryFulfilled.then(() => {
          api.dispatch(reviewsApi.util.invalidateTags(['Review']))
        })
      },
      invalidatesTags: (result, error, point) => [
        { type: 'Point', id: point?.id },
      ],
    }),
    deletePoint: build.mutation<void, number>({
      query: (pointId: number) => ({
        url: '',
        method: MethodsEnum.DELETE,
        credentials: 'include',
        params: {
          id: pointId,
        },
      }),
      invalidatesTags: (result, error, pointId) => [
        { type: 'Point', id: pointId },
      ],
    }),
  }),
})
